export type Bonus = {
  label: string;
  title: string;
  description: string;
  image: string;
};
export type Faq = {
  question: string;
  answer: string;
};
export type Need = {
  label: string;
  color: string;
};
export type Step = {
  title: string;
  description: string;
};
export type Situation = {
  title: string;
  description: string;
};
export type Moment = {
  need: string;
  title: string;
  description: string;
};
export type CardSlide = {
  reference: string;
  image: string;
};

export const checkoutUrl = 'https://botiquin-espiritual.impultienda.ar/checkout';

export const launchOffer = {
  label: 'Acceso completo',
  price: '$12.900',
  currency: 'ARS',
  paymentNote: 'Pago único. Sin suscripciones.'
};

export const cta = {
  label: 'QUIERO MI BOTIQUÍN ESPIRITUAL',
  short: 'QUIERO MI BOTIQUÍN',
  secondary: 'QUIERO TENERLO SIEMPRE CERCA',
  heroMicro: 'Acceso inmediato · Pago único · 4 bonos incluidos · Garantía de 7 días',
  offerMicro: 'Acceso inmediato · Garantía de 7 días',
  finalMicro: 'Acceso inmediato · $12.900 ARS · Pago único'
};

// Imágenes oficiales del producto.
export const productImages = {
  hero: 'https://cdn.magicpatterns.com/uploads/v5NZ9aPmPNniY7GAJEx7Ar/ChatGPT_Image_25_sept_2026,_09_35_10_a.m..png',
  heroAlt: 'Botiquín Espiritual: cajita imprimible junto a tarjetas bíblicas sobre una mesa',
  howItWorks: 'https://cdn.magicpatterns.com/uploads/v4HpZv8sZw8LLoQpZVK7Li/ChatGPT_Image_25_sept_2026,_09_43_19_a.m..png',
  howItWorksAlt: 'Cajita Botiquín Espiritual junto a tarjetas bíblicas con versículos',
  offer: 'https://cdn.magicpatterns.com/uploads/3oeq8ZFHFDrDB7aXjHkLRf/ChatGPT_Image_25_sept_2026,_10_00_21_a.m..png',
  offerAlt: 'Botiquín Espiritual completo: cajita, tarjetas bíblicas y los 4 bonos'
};

export const hero = {
  eyebrow: 'Una Palabra de Dios para cada momento',
  productName: 'Botiquín Espiritual',
  subtitle: 'Botiquín Espiritual reúne 50 tarjetas bíblicas organizadas según lo que estés viviendo: paz, fortaleza, confianza, esperanza, preocupación y momentos difíciles.',
  complement: 'Imprimilas una vez, armá tu Botiquín y tené Su Palabra siempre cerca.'
};

export const cardPreview = {
  title: 'Mirá tu Botiquín por dentro',
  subtitle: '50 tarjetas bíblicas listas para imprimir, recortar y tener siempre cerca.',
  closing: 'Cada tarjeta está organizada para ayudarte a encontrar rápidamente una Palabra de Dios según lo que estés viviendo.'
};

export const cardSlides: CardSlide[] = [{
  reference: 'Filipenses 4:6',
  image: 'https://cdn.magicpatterns.com/uploads/htEHY4hYd3B66s4uriaYED/01_Filipenses_4-6.png'
}, {
  reference: 'Jeremías 17:7',
  image: 'https://cdn.magicpatterns.com/uploads/tQUnrU9hvi7aF61mbScXsi/02_Jeremias_17-7.png'
}, {
  reference: 'Mateo 11:28',
  image: 'https://cdn.magicpatterns.com/uploads/aN75PmREotCMNEk9CQq6SR/03_Mateo_11-28.png'
}, {
  reference: 'Jeremías 33:3',
  image: 'https://cdn.magicpatterns.com/uploads/k6ivrZJRqSBLmwigzBwoaj/04_Jeremias_33-3.png'
}, {
  reference: '1 Pedro 5:7',
  image: 'https://cdn.magicpatterns.com/uploads/qbJ2XPZnxSAzZ4Gqb66ePh/05_1_Pedro_5-7.png'
}, {
  reference: 'Salmos 46:10',
  image: 'https://cdn.magicpatterns.com/uploads/ugtne2p3gYA3vQiAjMPbGv/06_Salmos_46-10.png'
}];

export const needs: Need[] = [
  { label: 'Paz', color: '#7fb3c9' },
  { label: 'Fortaleza', color: '#c97a3c' },
  { label: 'Confianza', color: '#5aa36b' },
  { label: 'Esperanza', color: '#d8b35a' },
  { label: 'Preocupación', color: '#8f6fc0' },
  { label: 'Momentos difíciles', color: '#b4544a' }
];

export const pain = {
  headline: 'Sabés que la Biblia tiene una Palabra para vos… pero no siempre sabés dónde encontrarla justo cuando la necesitás.',
  intro: 'Hay momentos en los que no necesitás leer durante horas. Necesitás detenerte, volver tu mirada a Dios y encontrar una Palabra que te acompañe en lo que estás viviendo.',
  situations: [{
    title: 'Cuando tu mente está llena de preocupaciones',
    description: 'y no sabés por dónde empezar el día.'
  }, {
    title: 'Cuando necesitás paz',
    description: 'y sentís que todo a tu alrededor va demasiado rápido.'
  }, {
    title: 'Cuando tenés que tomar una decisión',
    description: 'y querés ponerla primero en manos de Dios.'
  }, {
    title: 'Cuando necesitás fuerzas para seguir',
    description: 'y el cansancio pesa más de lo habitual.'
  }, {
    title: 'Cuando querés orar, pero no encontrás las palabras',
    description: 'y necesitás que Su Palabra hable primero.'
  }] as Situation[],
  close: 'Para esos momentos existe Botiquín Espiritual.'
};

export const mechanism = {
  title: 'Cuando más necesites una Palabra de Dios, no vas a tener que empezar a buscar.',
  description: 'Botiquín Espiritual organiza las Escrituras según lo que estés atravesando. Elegís lo que necesitás en ese momento y encontrás una tarjeta preparada para acompañarte.',
  needsLabel: 'Tarjetas organizadas por necesidad',
  closing: 'No son solamente 50 versículos. Es una manera sencilla de tener la Palabra de Dios preparada para los momentos en los que más necesitás volver a Ella.'
};

export const comparison = {
  looseTitle: 'Buscar un versículo en el momento',
  loose: [
    'Abrir el celular y empezar a buscar.',
    'Encontrar cientos de resultados distintos.',
    'Distraerte con notificaciones.',
    'Guardarlo y olvidarte después.',
    'Volver a empezar la próxima vez.'
  ],
  kitTitle: 'Con tu Botiquín Espiritual',
  kit: [
    'Tus tarjetas ya están organizadas.',
    'Encontrás rápidamente la categoría que necesitás.',
    'Podés leerlas sin depender del celular.',
    'Podés llevar una tarjeta con vos durante el día.',
    'También podés compartir una Palabra con alguien que la necesita.'
  ]
};

export const steps: Step[] = [{
  title: 'Identificá',
  description: '¿Qué necesita hoy tu corazón?'
}, {
  title: 'Elegí',
  description: 'Buscá la categoría que mejor representa lo que estás viviendo.'
}, {
  title: 'Leé',
  description: 'Tomá una tarjeta y dejá que la Palabra de Dios te acompañe.'
}, {
  title: 'Reflexioná y orá',
  description: 'Hacé una pausa, orá y volvé tu mirada a Él.'
}, {
  title: 'Llevala con vos',
  description: 'Guardala en tu cartera, Biblia, escritorio o donde puedas verla durante el día.'
}];

export const momentsTitle = 'Tu Botiquín puede acompañarte en momentos como estos';

export const moments: Moment[] = [{
  need: 'Paz',
  title: 'Al empezar el día',
  description: 'Antes de mirar el celular, elegí una tarjeta y comenzá poniendo tus pensamientos en Dios.'
}, {
  need: 'Preocupación',
  title: 'Cuando tu mente no se detiene',
  description: 'Elegí una Palabra que te ayude a soltar lo que no podés controlar y entregárselo a Él.'
}, {
  need: 'Fortaleza',
  title: 'Antes de algo importante',
  description: 'Una reunión, un trámite, una conversación difícil o una decisión. Llevá una tarjeta con vos.'
}, {
  need: 'Confianza',
  title: 'Frente a una decisión',
  description: 'Tomate unos minutos para orar y recordar que no caminás solo.'
}, {
  need: 'Momentos difíciles',
  title: 'Cuando alguien que amás lo necesita',
  description: 'Elegí una tarjeta y compartí una Palabra de ánimo con esa persona.'
}, {
  need: 'Esperanza',
  title: 'Al terminar el día',
  description: 'Cerrá el día con una Palabra, una oración y un momento de gratitud.'
}];

export const bonusesIntro = {
  eyebrow: 'Incluidos hoy, sin costo extra',
  title: '4 bonos para aprovechar todavía más tu Botiquín',
  text: 'Todo fue pensado para ayudarte a convertir estas tarjetas en un hábito sencillo de encuentro diario con Dios.'
};

export const bonuses: Bonus[] = [{
  label: 'Bono #1',
  title: 'Mapa de Emergencia Espiritual',
  description: 'Cuando no sabés qué tarjeta elegir, este mapa te ayuda a encontrar rápidamente una según lo que estés viviendo.',
  image: 'https://cdn.magicpatterns.com/uploads/u2E5DP1d5XnvJpQaUTowmA/02_bono_1_mapa_emergencia.png'
}, {
  label: 'Bono #2',
  title: 'Rutina 7 Minutos de Paz',
  description: 'Una rutina breve para detenerte, leer Su Palabra, reflexionar, orar y continuar tu día con mayor calma.',
  image: 'https://cdn.magicpatterns.com/uploads/2VbPqWf3iuy4rYQrqe3WR9/03_bono_2_rutina_7_minutos.png'
}, {
  label: 'Bono #3',
  title: 'Declaraciones de Fe para Momentos Difíciles',
  description: 'Palabras inspiradas en principios bíblicos para recordar verdades de fe cuando necesitás fortalecer tus pensamientos y tus palabras.',
  image: 'https://cdn.magicpatterns.com/uploads/gMXJ6bTD2aPYqqE7L18AyC/04_bono_3_declaraciones_fe.png'
}, {
  label: 'Bono #4',
  title: 'Rincón de Paz en Casa',
  description: 'Una guía sencilla para preparar un espacio de tu casa destinado a leer, reflexionar y orar.',
  image: 'https://cdn.magicpatterns.com/uploads/c7MAVvPZjT6HRbVrWtBFFf/05_bono_4_rincon_de_paz.png'
}];

export const socialProof = {
  title: 'Personas que ya confiaron en nuestros materiales',
  subtitle: 'Comentarios reales de nuestra comunidad',
  image: 'https://cdn.magicpatterns.com/uploads/wauH2spy5vWGejMa3b5Nmo/ChatGPT_Image_24_sept_2026,_06_00_05_p.m..png',
  imageAlt: 'Recomendaciones reales de clientes de Tu Conexión Educativa: Mariana González, Rocío Baldevenito Torres, Clarisa Sandoval, Naty Muñoz y Liliana Rajo.'
};

export const offerItems: string[] = ['50 Tarjetas Bíblicas', 'Cajita imprimible', 'Mapa de Emergencia Espiritual', 'Rutina 7 Minutos de Paz', 'Declaraciones de Fe para Momentos Difíciles', 'Rincón de Paz en Casa'];

export const afterPurchase = {
  title: '¿Qué pasa después de comprar?',
  steps: [{
    title: 'Realizás tu compra',
    description: 'Completás el pago de forma segura.'
  }, {
    title: 'Recibís tu acceso',
    description: 'Después de comprar recibís el acceso al material.'
  }, {
    title: 'Descargás los archivos',
    description: 'Guardás los PDF en tu celular o computadora.'
  }, {
    title: 'Imprimís y armás tu Botiquín',
    description: 'Recortás las tarjetas, armás tu Botiquín y empezás a usarlo.'
  }] as Step[]
};

export const guarantee = {
  title: 'Probalo con tranquilidad durante 7 días',
  body: 'Descargá tu Botiquín Espiritual, conocé el material y empezá a usarlo. Si sentís que no es para vos, contás con nuestra garantía de 7 días.'
};

export const faqs: Faq[] = [{
  question: '¿Es un producto físico o digital?',
  answer: 'Botiquín Espiritual es un producto digital. Después de comprar recibís los archivos en PDF para imprimir las tarjetas y la cajita en tu casa o en una gráfica. No se realiza ningún envío físico.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Después de completar tu compra recibís el acceso al material digital para descargarlo.'
}, {
  question: '¿Puedo verlo desde el celular?',
  answer: 'Sí. Podés consultar los archivos desde tu celular, aunque la experiencia principal del Botiquín está pensada para imprimir las tarjetas y tenerlas físicamente cerca.'
}, {
  question: '¿Necesito impresora?',
  answer: 'No. Podés descargar los archivos y llevarlos a cualquier gráfica o centro de impresión.'
}, {
  question: '¿Tengo que imprimir las 50 tarjetas juntas?',
  answer: 'No. Podés imprimir todo el Botiquín o comenzar solamente con las tarjetas que quieras utilizar.'
}, {
  question: '¿Puedo volver a imprimirlo?',
  answer: 'Sí. Podés guardar los archivos y volver a imprimir tus tarjetas cuando lo necesites.'
}, {
  question: '¿Qué incluye exactamente?',
  answer: 'Incluye 50 tarjetas bíblicas, una cajita imprimible y los 4 bonos presentados en esta página.'
}, {
  question: '¿Cómo funciona la garantía?',
  answer: 'Tu compra cuenta con una garantía de 7 días.'
}, {
  question: '¿Cómo accedo después de comprar?',
  answer: 'Después de completar el pago recibís las instrucciones para acceder y descargar el material.'
}];
